export const COMMISSIONS = {
    coefficient: '3',
    commission: '5',
};
export const METRICS = {
    minutes: '2',
};
// export const isProd = process.env.NODE_ENV === 'production';
export const isProd = false;
